/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, OnInit, Pipe, PipeTransform} from '@angular/core';
import {AnalyticsService} from './@core/utils/analytics.service';
import {NbIconLibraries} from '@nebular/theme';
import { PostalService } from './services/postal/postal.service';
import {SeoService} from './@core/utils/seo.service';

@Component({
    selector: 'ngx-app',
    template: '<nb-layout><nb-layout-column class="p-0"><router-outlet></router-outlet></nb-layout-column></nb-layout>',
})
export class AppComponent implements OnInit {

    constructor(private analytics: AnalyticsService,
                private seoService: SeoService,
                private iconLibraries: NbIconLibraries,
                private postalService: PostalService) {
        this.iconLibraries.registerFontPack('font-awesome', { packClass: 'fas', iconClassPrefix: 'fa' });
        this.iconLibraries.registerFontPack('font-awesome-fab', { packClass: 'fab', iconClassPrefix: 'fa' });
        this.iconLibraries.setDefaultPack('font-awesome');
    }

    ngOnInit(): void {
        this.analytics.trackPageViews();
        this.seoService.trackCanonicalChanges();
        this.postalService.getPostalFileData();
    }
}

@Pipe({ name: 'week' })
export class WeekPipe implements PipeTransform {
    transform(value: Date): number {
        return this.getWeekNumber(value);
    }

    private getWeekNumber(d: Date): number {
        // Copy date so don't modify original
        d = new Date(+d);
        d.setHours(0, 0, 0);
        // Set to nearest Thursday: current date + 4 - current day number
        // Make Sunday's day number 7
        d.setDate(d.getDate() + 4 - (d.getDay() || 7));
        // Get first day of year
        var yearStart = new Date(d.getFullYear(), 0, 1);
        // Calculate full weeks to nearest Thursday
        return Math.ceil((((d.valueOf() - yearStart.valueOf()) / 86400000) + 1) / 7);
    }
}
